import { render, staticRenderFns } from "./FogoWallet.vue?vue&type=template&id=31ce7fcf&scoped=true"
import script from "./FogoWallet.vue?vue&type=script&setup=true&lang=ts"
export * from "./FogoWallet.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FogoWallet.vue?vue&type=style&index=0&id=31ce7fcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ce7fcf",
  null
  
)

export default component.exports